module.exports = __webpack_public_path__ + "img/hsfwzx.df4d1d0f.png";